<template>
  <a-modal v-model="modal" title="修改制造BOM" width="85%" :maskClosable="false">
    <div v-if="modal" class="page-header-content">
      <ls-info-form :custom-width="{receiveFileList:'100%'}">
        <ls-info-item title="组织" :value="formData.organizationName" slot="organizationName"></ls-info-item>
        <ls-info-item title="物料编码" :value="formData.itemCode" slot="itemCode"></ls-info-item>
        <ls-info-item title="物料名称" :value="formData.itemName" slot="itemName" :IsContentTip="true" placement="topLeft" />
        <ls-info-item title="MBOM版本号" :value="formData.mbomVersion" slot="mbomVersion"></ls-info-item>
        <ls-info-item title="物料描述" :value="formData.itemDescription" slot="itemDescription" :IsContentTip="true" placement="topLeft" />
        <ls-info-item title="变更原因" slot="changeReason">
          <global-select
            :allowClear="false"
            :value.sync="formData.changeReason"
            :selectData="changeReasonList"
            selectType="selectFilter"
            :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
          />
        </ls-info-item>
        <ls-info-item title="生效日期" slot="startDate">
          <a-date-picker v-model="formData.startDate" valueFormat="YYYY-MM-DD 00:00:00" :disabled-date="disabledDate"/>
        </ls-info-item>
      </ls-info-form>
      <a-tabs v-model="tabSelect" :animated="false" class="tab-custom-content">
        <a-tab-pane :key="1" tab="BOM明细">
          <div class="table-page-operator-wrapper">
            <a-button @click="addLine" type="primary">新增明细</a-button>
          </div>
          <a-form-model
            :model="formData"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            ref="editUpdateForm"
          >
            <ls-api-table
              ref="updateEditTable"
              class="update-change-table"
              :columns="columns"
              :dataSource="dataList"
              :tableProps="{}"
              :pagination="false"
              :scroll="{ y: 400, x: 600 }"
              rowKey="key_id"
            >
              <template #itemCode="{record, index}">
                <span v-if="record.id">{{ record.itemCode }}</span>
                <a-form-model-item
                  v-else
                  :prop="'children.'+index+'.itemCode'"
                  :rules="[{required: true, message: ' ', trigger: 'change'}]">
                  <global-select
                    :key="record.key_id + index + '_select'"
                    v-model="record.itemCode"
                    selectType="selectSearch"
                    :focusGet="true"
                    :dropdown-match-select-width="false"
                    requestApi="/scp/scpMrpSystemItems/planItemsBoxNew"
                    :selectItem="{ value: 'selectedValue', label: 'label' }"
                    :setParams="{ organizationCode: 'A001' }"
                    searchParam="label"
                    sourseField="res"
                    :totalNum="9999999999"
                    @change="(val, selectList) => changeSelect(val, selectList, record)"
                  />
                </a-form-model-item>
              </template>
              <template #componentQuantity="{record, index}">
                <a-form-model-item
                  :prop="'children.'+index+'.componentQuantity'"
                  :rules="[
                    { required: true, message: ' ', trigger: 'blur' },
                    { validator: validateComponentQuantity, trigger: ['blur', 'change'] }
                  ]">
                  <a-input-number
                    style="width: 100%"
                    v-model="record.componentQuantity"
                    :min="0"
                    placeholder="请输入整数"
                    :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{5}).*$/, '$1$2.$3', '')"
                    :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{5}).*$/, '$1$2.$3', '')" />
                </a-form-model-item>
              </template>
              <!-- 备注 -->
              <template slot="remark" slot-scope="{ record }">
                <a-input v-model="record.remark" :maxLength="200" />
              </template>
              <template #operation="{record}">
                <a @click="handleDelete(record)" class="ml8">删除</a>
              </template>
            </ls-api-table>
          </a-form-model>
        </a-tab-pane>
      </a-tabs>
    </div>
    <template #footer>
      <a-space>
        <a-button @click="modal=false">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确认提交</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'
import { apiMbomBillStructuresEdit } from '@/api/mdm/matter/manufacture-mbom.js'
import cacheRequest from '@/mixins/cacheRequest'
export default {
  name: "UpdateModal",
  mixins: [cacheRequest],
  data () {
    return {
      modal: false,
      loading: false,
      tabSelect: 1,
      changeReasonList: [],
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      formData: {
        startDate: '',
        children: []
      },
      columns: [
        { title: '物料编码', width: 160, align: 'center', dataIndex: 'itemCode', scopedSlots: { customRender: 'itemCode' } },
        { title: '物料名称', width: 150, align: 'center', dataIndex: 'itemName' },
        { title: '物料描述', width: 180, align: 'center', dataIndex: 'itemDescription' },
        { title: '用量', width: 100, align: 'center', dataIndex: 'componentQuantity', scopedSlots: { customRender: 'componentQuantity' } },
        { title: '单位', width: 90, align: 'center', dataIndex: 'materialUnit' },
        { title: '备注', width: 160, align: 'center', dataIndex: 'remark', scopedSlots: { customRender: 'remark' } },
        {
          title: '操作',
          width: 90,
          align: 'center',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    }
  },
  computed: {
    dataList () {
      return this.formData.children.filter(item => item.deleted !== 1)
    }
  },
  methods: {
    // 用量必须大于0
    validateComponentQuantity (rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback()
        return
      }
      if (Number(value) <= 0) {
        callback(new Error(' '))
        return
      }
      callback()
    },
    // 验证表单数据
    validateForm() {
      if(!this.formData?.changeReason) {
        this.$message.error('请选择变更原因')
        return false
      }
      if(!this.formData?.startDate) {
        this.$message.error('请选择生效日期')
        return false
      }
      // 验证生效日期不能早于当天
      const selectedDate = this.$moment(this.formData.startDate)
      const today = this.$moment().startOf('day')
      if(selectedDate.isBefore(today)) {
        this.$message.error('生效日期不能早于当天')
        return false
      }
      const effectList = this.formData?.children?.filter(item => item.deleted !== 1) || []
      if(effectList.length < 1) {
        this.$message.error('请添加 BOM 明细')
        return false
      }
      return true
    },
    // 提交
    submit () {
      if (!this.validateForm()) {
        return
      }
      this.$refs.editUpdateForm.validate(valid => {
        if(valid) {
          this.loading = true;
          apiMbomBillStructuresEdit(this.formData).then(res => {
            if (res?.code === 200) {
              this.$message.success(res?.msg || '操作成功')
              this.$emit("refresh")
              this.modal = false
            }
          }).finally(() => {
            this.loading = false;
          })
        } else {
          this.$message.error('请检查必填项')
        }
      })
    },
    show(selectedRow) {
      this.formData = cloneDeep(selectedRow)
      // 生效时间都设为当天
      this.formData.startDate = this.$moment(new Date()).format('YYYY-MM-DD 00:00:00')
      this.modal = true
    },
    // 选择限制当前和以后日期
    disabledDate (current) {
      return current && current <= this.$moment().subtract(1, 'day');
    },
    // 删除
    handleDelete(record) {
      if (!record) {
        return
      }
      // 如果有id就就赋值deleted，如果没有id（未保存的）直接删除
      const index = this.formData.children.findIndex(item => (record.id && item.id === record.id) || (record.key_id && item.key_id === record.key_id))
      if (index > -1) {
        if(record.id) {
          this.$set(this.formData.children, index, {
            ...this.formData.children[index],
            deleted: 1
          })
        } else {
          this.formData.children.splice(index, 1)
        }
        this.$message.success('删除成功')
        this.reFresh()
      }
    },
    // 选择物料变化
    changeSelect(val, selectList, record) {
      if(val) {
        const getSelect = selectList.find(item => item.selectedValue === val)
        record.itemName = getSelect.bringOutDataOne
        record.itemDescription = getSelect.bringOutDataTwo
        record.materialUnit = getSelect.primaryUom
      } else {
        record.itemName = ''
        record.itemDescription = ''
        record.materialUnit = ''
      }
    },
    addLine() {
      // 生成唯一的 id
      const keyId = Date.now()
      const newLine = {
        key_id: keyId,
        deleted: 0, // 未删除
        itemCode: '', // 物料编码
        itemName: '', // 物料名称
        itemDescription: '', // 物料描述
        componentQuantity: '', // 用量
        materialUnit: '', // 单位
        remark: '', // 备注
        changeReason: '' // 变更原因
      }
      this.$set(this.formData, 'children', [...(this.formData.children || []), newLine])
      this.reFresh()
    },
    // 刷新
    reFresh() {
      setTimeout(() => {
        this.$refs.updateEditTable.SearchData();
      }, 100)
    }
  },
  created() {
    this.cacheLookupRequest('MES_CHANGE_ITEM_REASON', { lookupType: 'MES_CHANGE_ITEM_REASON', current: 1, pageSize: 999 }, 'changeReasonList')
  }
}
</script>

<style lang="less" scoped>
.page-header-content{
  /deep/.ant-select{
    width: 160px;
    max-width: 100%;
  }
}

.update-change-table{
  /deep/.ant-form-item{
    margin-bottom: 0;
  }
  /deep/.ant-form-item-control-wrapper{
    width: 100%;
  }
  /deep/ .ant-form-explain, .ant-form-extra{
    min-height: 0;
    height: 0;
  }
}
</style>
